<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/event_production/bg_Seamless-Load-In-Out.jpg" alt=""></transition></div>
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Event Production" h1="Seamless Load In/Load Out" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <Feature @click.native="showImage = true; currentImage = 0" inPageBottom hasAction label="Drivable<br/>Stadium<br/>Floor" description="No grass field or turf<br/>Direct truck to<br/>stadium floor access" icon="event_production/icon_truck.svg" />
                        <Feature @click.native="showImage = true; currentImage = 1" inPageBottom hasAction label="3 Additional<br/>Loading<br/>Docks" description="Within 400 feet of<br/>stadium floor" icon="event_production/icon_dock.svg" />
                        <Feature @click.native="showImage = true; currentImage = 2" inPageBottom hasAction label="Large, Covered<br/>Marshalling<br/>Area" description="For easy truck<br/>maneuverability<br/>and storage" icon="event_production/icon_covered-truck.svg" />
                        <Feature @click.native="showImage = true; currentImage = 3" inPageBottom hasAction label="Ample Tour<br/>Production<br/>Parking" description="With ability to power<br/>up to 24 buses<br/>on site" icon="event_production/icon_parking.svg" />
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageBottom>    
    <FullscreenImages :images="images[currentImage]" :showImage="showImage" @hide="showImage = false"/>
  </div>
</template>

<script>


import PageBottom from "@/patterns/PageBottom.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import Feature from "@/patterns/Feature.vue";
import FullscreenImages from "@/patterns/FullscreenImages.vue";

export default {
  name: "SeamlessLoadHighlights",
  components: {  PageBottom, TitleContent, Feature, FullscreenImages},
  data: () => ({
    scrollContent: false, 
    showImage:false,
    currentImage:0,
    images : [
        [require('@/assets/images/event_production/seamless_load/bg_drivable-stadium-floor.jpg')],
        [require('@/assets/images/event_production/seamless_load/bg_3-additional-loading-docks.jpg')],              
        [require('@/assets/images/event_production/seamless_load/bg_large-covered-marshalling-area.jpg')],        
        [require('@/assets/images/event_production/seamless_load/bg_ample-tour-production-parking.jpg')],
    ]   
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>